
export function archiveSwitcher() {
    const el = document.querySelector('#archiveSwitcher')
    el.onchange = (e) => {
        const control = document.querySelector('.custom-switch .custom-control-input')
        if (control?.classList.contains('active')) {
            control.classList.remove('active')
        }
        e.target.closest('.archiveLink').click()
    }
}